import { Reveal } from './Reveal';

export const SectionHeader = ({ eyebrow, title, text, align = 'left', dark = false, className = '' }) => (
  <Reveal className={`${align === 'center' ? 'text-center' : ''} ${className}`}>
    {eyebrow && <p className="eco-eyebrow">{eyebrow}</p>}
    <h2 className={`eco-section-title mt-3 ${dark ? 'text-white' : 'text-eco-ink'} ${align === 'center' ? 'mx-auto max-w-3xl' : 'max-w-3xl'}`}>{title}</h2>
    {text && <p className={`eco-body mt-3 ${dark ? 'text-white/65' : ''} ${align === 'center' ? 'mx-auto' : ''} max-w-2xl`}>{text}</p>}
  </Reveal>
);
